export class ProjectDesignationDto {
    id: number;
    name: string;
}

export class ProjectDesignation {
    id: number | null;
    name: string;
    projectType: ProjectType | null;
    projectPaymentStatus: ProjectPaymentStatus | null;

    constructor(data?: Partial<ProjectDesignation>) {
    this.id = data?.id ?? null;
    this.name = data?.name ?? '';
    this.projectType = data?.projectType ?? null;
    this.projectPaymentStatus = data?.projectPaymentStatus ?? null;
  }
}

export enum ProjectType {
    MAP = 1,
    NMAP = 2,
    KCG = 3
}

export enum ProjectPaymentStatus {
    Paid = 1,
    NonPaid = 2
}